<template>
    <div
        class="numbers-group"
        :class="{promo8800: group.isUpsale}"
        data-element="numbers-group"
    >
        <h4 class="bold">{{ displayTitle }}</h4>
        <div class="row">
            <div class="numbers-type_head col-md-10">
                <h4>
                    <template v-if="!showPrice">
                        Условия подключения, стоимость и абонентская плата - по запросу.
                    </template>
                    <template v-else>
                        Абонентская плата -
                        <span>
                        <strong :class="{'text-orange': showMonthlyDiscount}">
                            <s class="text-gray fs-sm price-old" data-element="regular-price-old"
                               v-if="showMonthlyDiscount">{{ formatPrice(group.priceMonthlyFull) }}</s>
                            <span data-element="regular-price">{{ formatPrice(group.priceMonthly) }}</span>
                        </strong>
                        руб./месяц.
                    </span>
                        Подключение -
                        <span>
                        <strong :class="{'text-orange': showOnceDiscount}">
                            <s class="text-gray fs-sm price-old" data-element="connection-price-old"
                               v-if="showOnceDiscount">{{ formatPrice(group.priceOnceFull) }}</s>
                            <span data-element="connection-price">{{ formatPrice(group.priceOnce) }}</span>
                        </strong>
                        руб./номер.
                    </span>
                    </template>
                </h4>
                <span
                    class="stiker stiker--hit"
                    data-element="demo-sticker"
                    ref="sticker"
                    :title="demoVatsStickerText"
                    v-if="isDemoVats"
                >
                первые 14 дней бесплатно
                </span>
                <span
                    class="stiker stiker--hit"
                    data-element="discount-sticker"
                    v-if="group.discount"
                >
                    {{ group.discount.name }}
                </span>
            </div>
            <div class="col-md-2 numbers-group__toggle" @click="$emit('toggleActive')">
                <span :class="{'active': !hidden}"></span>
            </div>
        </div>
        <div class="numbers-group__block" v-show="!hidden">
            <div
                class="numbers-sel-tariff"
                data-element="tariff-select"
                v-if="isFMC && group.provider"
            >
                <span>Тариф:</span>
                &nbsp;
                <a href=""
                   class="dashed"
                   data-element="tariff-select-button"
                   rel="nofollow"
                   @click.prevent="showSelectTariffModal"
                >
                    <span>{{ displaySelectTariff }}</span>
                </a>
                <img
                    class="provider-img"
                    :src="group.provider.logo"
                    v-if="group.provider.logo"
                />
            </div>
            <p>
                <small class="footnote" v-if="is8800">
                    Оформление номеров вида: 8 (800) 775-xxxx и 8 (800) 585-xxx возможно только на
                    юридическое
                    лицо!
                </small>
            </p>
            <template v-if="canBuy && canBuyMore ">
                <a
                    href=""
                    class="dashed number-random"
                    :class="{active: chooseRandomDone}"
                    data-element="numbers-random-choice"
                    @click.prevent="chooseRandom"
                >
                    <template v-if="!chooseRandomDone">
                        <svg class="icon icon--shuffle">
                            <use xlink:href="#icon--shuffle"></use>
                        </svg>
                        <span class="choose">Выбрать случайный</span>
                    </template>
                    <template v-else>
                    <span class="chosen">
                        <i class="ui ui-check va-middle text-green"></i>
                        &nbsp;
                        <span class="dashed">Добавлено</span>
                    </span>
                    </template>
                </a>
            </template>
            <template v-else>
                <span
                    href=""
                    class="dashed number-random opacity-block"
                    data-element="numbers-random-choice"
                >
                    <svg class="icon icon--shuffle">
                        <use xlink:href="#icon--shuffle"></use>
                    </svg>
                    <span class="choose">Выбрать случайный</span>
                 </span>
            </template>
            <div class="numbers-items">
                <template v-if="groupingCount > 0">
                    <div class="numbers-items__items">
                        <div
                            class="numbers-items__block"
                            data-element="nums-block"
                            :key="key"
                            v-for="(items, key) in displayNumbers"
                        >
                            <NumbersBlock
                                :items="items"
                                :canBuy="canBuy"
                                :canBuyMore="canBuyMore"
                                :patterns="patterns"
                                :blockLoading="blockLoading"
                                @addNumbers="(numbers, blockId) => addNumbers(numbers, {blockId: blockId})"
                                @removeNumbers="(numbers, blockId) => removeNumbers(numbers, {blockId: blockId})"
                            />
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div class="numbers-items__items">
                        <div
                            class="numbers-items__item"
                            :key="item.id"
                            v-for="item in displayNumbers"
                        >
                            <NumberItem
                                :item="item"
                                :canBuy="canBuy"
                                :canBuyMore="canBuyMore"
                                :patterns="patterns"
                                @addNumber="(number) => addNumber(number)"
                                @removeNumber="(number) => removeNumber(number)"
                            />
                        </div>
                        <div class="more-numbers__btn" v-if="hideShowMoreBtn">
                            <a href="/shop/numbers/">Больше номеров</a>
                        </div>
                    </div>
                    <div class="numbers-items__more" v-if="!isLastPage && !hideShowMoreBtn">
                        <Button
                            title="Показать еще"
                            size="md"
                            :loading="loading"
                            @click="$emit('load')"
                        />
                    </div>
                </template>
                <a
                    data-type="link"
                    class="numbers-items__register"
                    data-toggle="modal"
                    data-target=".js-modal-registration"
                    v-if="showRegLink"
                >
                <span>
                    <b>Зарегистрируйтесь</b><br>чтобы увидеть больше номеров
                </span>
                </a>
            </div>
        </div>
    </div>
</template>


<script>
import NumbersGroup from "../../numbers-page/components/NumbersGroup";

export default {
    name: "NumbersGroupBlock",
    extends: NumbersGroup,
    props: {
        hidden: {
            type: Boolean,
            default: false,
        },
    },

}
</script>

<style scoped>
.more-numbers__btn {
    width: 100%;
    text-align: right;
    padding-right: 24px;
}
.numbers-group__toggle {
    cursor: pointer;
}
</style>